export function isEntityDataChangeEvent(payload) {
    return Boolean(payload.operation === 'create' ||
        payload.operation === 'update' ||
        payload.operation === 'delete');
}
